import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { AssetService } from 'src/app/services/asset/asset.service';
import { ClientService } from 'src/app/services/client/client.service';
import { Constants } from 'src/app/constants/constants';
import { AssetTypeModel } from 'src/app/models/asset-type.model';


@Component({
  selector: 'modal-assignable-asset',
  templateUrl: './modal-assignable-asset.component.html',
  styleUrls: ['./modal-assignable-asset.component.scss'],
})
export class ModalAssignableAssetComponent implements OnInit {


  assetGroup: string = "";
  assets: Array<AssetTypeModel> = [];
  selectedAsset: AssetTypeModel = null;


  constructor(public appearanceService: AppearanceService,
   public userService: UserService, public modalController: ModalController,
   public assetService: AssetService, public clientService: ClientService) {

  }


  ngOnInit() 
  {

  }


  ionViewWillEnter()
  {
    var groups = this.clientService.getAssetGroupsForOrganisation(this.clientService.getOrganisationUid());

    if (groups.length == 1)
    {
      this.assetGroup = groups[0].uid.toString();
      this.assetGroupSelected();
    }
  }


  ionViewWillLeave()
  {

  }


  assetGroupSelected()
  {
    this.assets = new Array<AssetTypeModel>();
    this.selectedAsset = null;

    var payload = {
      ClientUid:  this.clientService.getClientUid(),
      AssetGroupUid: this.assetGroup,
      OrganisationUid: this.clientService.getOrganisationUid()
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.assetService.getAllAssetTypesInAssetGroup(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          for (var i = 0; i < response.AssetTypes.length; i++)
          {
            var entry = response.AssetTypes[i];
            var newAsset = new AssetTypeModel();
            newAsset.assetTypeUid = entry.assetTypeUid;
            newAsset.assetTypeName = entry.assetName;
            this.assets.push(newAsset);
          }
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    });
  }


  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'AssignAssetModal');
  }


  addAssignableAsset()
  {
    var returnData = { assignableAssetType: this.selectedAsset };
    this.modalController.dismiss(returnData, null, 'AssignAssetModal');
  }

}
